import loglevelInstance, { log, logError } from './logger'
import {
  getGenericRuntimeErrorMessage,
  getGenericPromiseRejectionErrorMessage
} from './utils'

export * from './types'

export default {
  log,
  logError,
  loglevelInstance,
  getGenericRuntimeErrorMessage,
  getGenericPromiseRejectionErrorMessage
}
